/* eslint-disable default-case  */
export const PLATFORM_SUGGESTED = "Suggested-Answer";
export const PLATFORM_NEW = "New";
export const PLATFORM_AWAITING_CUSTOMER = "Customer";
export const PLATFORM_AWAITING_EXPERT = "Expert";
export const PLATFORM_REVIEW = "Review";
export const PLATFORM_REVIEW_ESC = "Review-Escalation";
export const PLATFORM_QUARANTINE_NEW = "Quarantine-New";
export const PLATFORM_QUARANTINE_CUST = "Quarantine-Customer";
export const PLATFORM_QUARANTINE_EXPERT = "Quarantine-Expert";
export const PLATFORM_QUARANTINE_EXPERT_ESC = "Quarantine-Expert-Escalation";
export const PLATFORM_QUARANTINE_ESCALATED = "Quarantine-Escalated";
export const PLATFORM_QUARANTINE_ESCALATED_REVIEW = "Quarantine-Escalated-Review";
export const PLATFORM_QUARANTINE_RESOLVED = "Quarantine-Resolved";
export const PLATFORM_QUARANTINE_RESOLVED_REVIEW = "Quarantine-Resolved-Review";
export const PLATFORM_QUARANTINE_TIMEOUT = "Quarantine-Timed-Out";
export const PLATFORM_REPORTED = "Reported";
export const PLATFORM_ESCALATED = "Escalated";
export const PLATFORM_RESOLVED = "Resolved";
export const PLATFORM_TIMEOUT = "Timed-Out";
export const PLATFORM_UNKNOWN = "Unknown";
export const PLATFORM_ARCHIVED = "Archived";
const SCHEDULED = "scheduled";
const NOT_SCHEDULED = "not_scheduled";
const PENDING = "pending";
const IN_PROGRESS = "in_progress";
const COMPLETE = "complete";

/**
 * Should resolve a message to one of the following states:
 *
 * Suggested
 * New
 * Awaiting Customer
 * Awaiting Expert
 * Review
 * Review New
 * Quarantine New
 * Quarantine Customer
 * Quarantine Response
 * Quarantine Forward
 * Quarantine Review
 * Reported
 * Forwarded
 * Resolved
 * Time Out
 * Unknown
 *
 * @param {object} message
 */
export const calculatePlatformStateFromMessage = message => {
  const {
    archived,
    state,
    releaseState,
    reportedAt,
    primaryResponseDate,
    escalatedAt,
    lifecycleState,
    reviewState,
    lastExpertDialogueDate,
    lastCustomerDialogueDate,
    custConfirmation
  } = message;
  if (archived) {
    return PLATFORM_ARCHIVED;
  }
  if (reportedAt) {
    return PLATFORM_REPORTED;
  }
  if (releaseState === PENDING) {
    switch (lifecycleState) {
      case "escalated":
        {
          if (reviewState === COMPLETE) {
            return PLATFORM_QUARANTINE_ESCALATED_REVIEW;
          }
          return PLATFORM_QUARANTINE_ESCALATED;
        }
      case "resolved":
        {
          if (reviewState === COMPLETE) {
            return PLATFORM_QUARANTINE_RESOLVED_REVIEW;
          }
          return PLATFORM_QUARANTINE_RESOLVED;
        }
      case "timedout":
        return PLATFORM_QUARANTINE_TIMEOUT;
      case "in_progress":
        {
          if (escalatedAt) {
            return PLATFORM_QUARANTINE_EXPERT_ESC;
          }
          if (!primaryResponseDate) {
            return PLATFORM_QUARANTINE_NEW;
          }
          if (lastExpertDialogueDate < lastCustomerDialogueDate && !custConfirmation) {
            return PLATFORM_QUARANTINE_CUST;
          }
          return PLATFORM_QUARANTINE_EXPERT;
        }
    }
  }
  if (lifecycleState === IN_PROGRESS) {
    if (state === "prep") {
      return PLATFORM_SUGGESTED;
    }
    if (reviewState === NOT_SCHEDULED) {
      if (!primaryResponseDate) {
        return PLATFORM_NEW;
      }
      return PLATFORM_AWAITING_EXPERT;
    }
    if (reviewState === SCHEDULED) {
      return PLATFORM_AWAITING_CUSTOMER;
    }
    if (reviewState === IN_PROGRESS) {
      if (escalatedAt) {
        return PLATFORM_REVIEW_ESC;
      } else {
        return PLATFORM_REVIEW;
      }
    }
  }
  switch (lifecycleState) {
    case "escalated":
      return PLATFORM_ESCALATED;
    case "resolved":
      return PLATFORM_RESOLVED;
    case "timedout":
      return PLATFORM_TIMEOUT;
    default:
      return PLATFORM_UNKNOWN;
  }
};